import { AttributeAssignmentRow } from 'src/app/models/attribute-assignment-row';

export class AttributeAssignmentDialogResult {
    public constructor(
        public confirmation: boolean,
        public value: AttributeAssignmentRow = null
    ) {}
}
